module.exports = __webpack_public_path__ + "img/magento-modules-customization.d111a541.jpg";